import { type ChartTooltipColor } from '@/lib/ui/variants'

export enum ControlImpact {
  CRITICAL = 'CRITICAL',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export const WEIGHT_RANGES = {
  [ControlImpact.CRITICAL]: { min: 5, max: Infinity },
  [ControlImpact.MEDIUM]: { min: 3, max: 4 },
  [ControlImpact.LOW]: { min: 1, max: 2 },
} as const

export const IMPACT_TO_COLOR: Record<ControlImpact, ChartTooltipColor> = {
  [ControlImpact.CRITICAL]: 'critical',
  [ControlImpact.MEDIUM]: 'medium',
  [ControlImpact.LOW]: 'low',
}

export const getImpactFromWeight = (weight: number): ControlImpact => {
  for (const [impact, range] of Object.entries(WEIGHT_RANGES)) {
    if (weight >= range.min && weight <= range.max) {
      return impact as ControlImpact
    }
  }

  // Default to LOW_PRIORITY for any unexpected weights
  return ControlImpact.LOW
}

export const controlImpactLabel: Record<ControlImpact, string> = {
  [ControlImpact.CRITICAL]: 'Critical',
  [ControlImpact.MEDIUM]: 'Medium-priority',
  [ControlImpact.LOW]: 'Low-priority',
}

export const WEIGHT_VALUES = [1, 2, 3, 4, 5] as const

export type ControlWeight = (typeof WEIGHT_VALUES)[number]

export const DEFAULT_WEIGHT: ControlWeight = 1

export const getWeightLabelSuffix = (weight: ControlWeight): string => {
  return `${weight === 1 ? ' - Low' : weight === 5 ? ' - Critical' : ''}`
}

export const getWeightLabel = (weight: ControlWeight): string => {
  return `${weight}${getWeightLabelSuffix(weight)}`
}
